module.exports = __webpack_public_path__ + "img/honor_2.dc603088.png";